import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import closeModal from '../../actions/Modals/closeModal'
import requestPrices from '../../actions/price/requestPrices'
import { requestSynchronization } from '../../actions/synchronize/synchronize'
import {
  fireToastError,
  fireToastSuccess,
} from '../../actions/toasts/fireToast'
import { Modals } from '../../containers/Modals/ModalContainer'
import i18n from '../../i18n'
import savePriceForm from '../../models/Price/savePriceForm'
import {
  PriceFormActions,
  PriceGridAction,
} from '../../reducers/price/actionNames'
import { getUserObjectId } from '../../reducers/userObject/selectors/object'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { PriceEditModalActions } from '../../reducers/priceEdit/actionNames'
import savePriceForm2 from '../../models/Price/savePriceForm2'
import {
  getPriceEditModalData,
  getPriceEditModalFields,
  getPriceEditModalKeepRestrictions,
  getPriceEditModalRoomId,
  getPriceEditModalType,
} from '../../reducers/priceEdit/selectors'
import { get, isEmpty } from 'lodash'
import { getPriceConfig } from '../../reducers/price/selectors/price'
import {
  precomputedPricesCache,
  precomputedRestrictionsCache,
} from '../../reducers/bookingCalendar/selectors/rooms'

function* submitForm(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SavePriceForm)
    const [{ calendarId, service }, objectId] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, savePriceForm),
      ),
    ])

    yield Effects.call(
      service,
      action.values,
      String(objectId),
      String(calendarId),
    )

    const { selectedRooms } = action.values
    yield Effects.put(requestPrices(selectedRooms.map(v => +v)))

    yield Effects.put(closeModal(Modals.OpenPriceFormModal))

    yield Effects.put(
      fireToastSuccess(
        i18n.t('BBO_1494_submit_success'),
        5000,
        'Main',
        'SubmitSuccess',
      ),
    )
  } catch (e) {
    if (e.message === '412') {
      yield Effects.put(requestSynchronization())
    }
    //console.error(e)
    yield Effects.put(closeModal(Modals.OpenPriceFormModal))
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

function* savePrices(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SavePriceForm2)
    const [{ calendarId, service }, objectId] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.select(getUserObjectId),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, savePriceForm2),
      ),
    ])

    const type = yield Effects.select(getPriceEditModalType)
    const data = yield Effects.select(getPriceEditModalData)
    const fields = yield Effects.select(getPriceEditModalFields)
    const roomId = yield Effects.select(getPriceEditModalRoomId)
    const config = yield Effects.select(getPriceConfig)
    const keepRestrictions = yield Effects.select(
      getPriceEditModalKeepRestrictions,
    )

    const errors = validateData(data.prices, fields)

    if (errors) {
      yield Effects.put({
        type: PriceEditModalActions.SetErrors,
        errors,
      })
      yield Effects.put(
        fireToastError(
          i18n.t('BBO_2512_prices_cant_be_empty_enter_zero'),
          5000,
          'Main',
          'ServerError',
        ),
      )
      return
    }

    precomputedPricesCache.delete(roomId)
    precomputedPricesCache.delete(`pricesMapped-${roomId}`)
    precomputedRestrictionsCache.delete(roomId)
    precomputedRestrictionsCache.delete(`restrictionsMapped-${roomId}`)

    yield Effects.call(
      service,
      { ...data, keepRestrictions: keepRestrictions === true },
      roomId,
      type,
      String(objectId),
      String(calendarId),
      config,
    )

    yield Effects.put({ type: PriceGridAction.RequestNewPrices, reload: true })

    yield Effects.put({
      type: PriceEditModalActions.ClosePriceEditModal,
      payload: true,
    })

    yield Effects.put(
      fireToastSuccess(
        i18n.t('user_settings_updated'),
        5000,
        'Main',
        'SubmitSuccess',
      ),
    )
  } catch (e) {
    if (e.message === '412') {
      yield Effects.put(requestSynchronization())
    }
    //console.error(e)
    yield Effects.put(
      fireToastError(
        i18n.t('error_server_response_2'),
        5000,
        'Main',
        'ServerError',
      ),
    )
  }
}

const validateData = (prices, fields) => {
  let errors = {}
  fields.forEach(field => {
    const value = get(prices, field, undefined)
    if (value === undefined || value === '' || value === null) {
      errors[field] = i18n.t('BED_11807_meals_error_empty')
    }
  })
  if (fields.length === Object.keys(errors).length) {
    return false
  }

  return isEmpty(errors) ? false : errors
}

export default function*() {
  yield Effects.takeLatest(PriceFormActions.SubmitPriceForm, submitForm)
  yield Effects.takeEvery(PriceEditModalActions.Save, savePrices)
}
